// useLanguageSelectors.ts
import {
    getSafeLocaleObject,
    SUPPORTED_LOCALES,
    SupportedLocaleCode,
} from '@constants/locales';
import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (language: SupportedLocaleCode) => {
        i18n.changeLanguage(language);
    };

    const supportedLanguages = SUPPORTED_LOCALES;
    const currentLanguage = getSafeLocaleObject(i18n.language);

    return {
        changeLanguage,
        currentLanguage,
        supportedLanguages,
    };
};

export default useLanguage;
